import React, { useState, useEffect, useRef, useCallback } from "react";
import "swiper/css";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";
import { useSelector, useDispatch } from "react-redux";
import { debounce } from "lodash";
import DocumentPreview from "../Create-Investment/documentpreview";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import CustomDropdownWithFetch from "../../Components/CustomDropdown/custom-dropdown-fetchAPI";
import { useRoutingNumberValidation } from "../../Components/bank-validations/use-routing-number-validation";

import {
  setUserProfilePic,
  setUserProfilePicDownloadUrl,
} from "../../Redux/store/userSlice";
import countriesData from "../../Data/CountryCodes.json";

const validator = require("validator");

const CustomerDetails = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const userId = useSelector((state) => state.user.userId);
  const cardCurrencyName = useSelector((state) => state.user.cardCurrencyName);

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const [filter, setFilter] = useState("profile");
  const [isOpenEdit, setisOpenEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [currentBank, setcurrentBank] = useState({});
  const [isModalOpenBankEdit, setIsModalOpenBankEdit] = useState(false);
  const [newFirstName, setNewFirstName] = useState("");
  const [countries, setCountries] = useState([]);

  const togglePopupEdit = () => {
    setisOpenEdit(!isOpenEdit);
    setcurrentPassword("");
    setnewPassword("");
    setconfirmPassword("");
    setShowConfirmPassword(false);
    setShowCurrentPassword(false);
    setShowNewPassword(false);
  };
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState("");
  const [showcurrentPassword, setShowCurrentPassword] = useState(false);
  const [currentpassword, setcurrentPassword] = useState("");
  const [transitError, setTransitError] = useState("");
  const [shownewPassword, setShowNewPassword] = useState(false);
  const [newPassword, setnewPassword] = useState("");
  const [isNewChangeFees, setisNewChangeFees] = useState(true);
  const [profileData, setprofileData] = useState({});
  const [accountAnalytics, setAccountAnalytics] = useState({});
  const [addressData, setAddressData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenProfile, setIsModalOpenProfile] = useState(false);
  const [countryCode, setCountryCode] = useState("AU");
  const [institutionNumber, setinstitutionNumber] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [bankdata, setBankdata] = useState([
    {
      id: 0,
      bank_name: "Test",
      account_name: "Dummmy",
      account_number: null,
      bsb: null,
      swift: "082-356",
      branch_address: "333 George St, Sydney NSW 2000 Australia",
      currency: "AUD",
    },
  ]);
  const [accountdata, setAccountData] = useState({
    no_of_active_accounts: 0,
    no_of_archieved_accounts: 0,
    active_accounts: {
      my_investments: 0,
    },
    archieved_accounts: {},
  });
  const [cardDatanew, setcardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [isOpenEditCashAccount, setisOpenEditCashAccount] = useState(false);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [addressLine3, setAddressLine3] = useState("");
  const [toBsb, setToBsb] = useState("");
  const [toCurrency, setToCurrency] = useState("");
  const [toAccountName, setToAccountName] = useState("");
  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: "AUD",
  });
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: "AU",
    label: "Australia",
  });
  const [toAccountNumber, setToAccountNumber] = useState("");
  const [toBank, setToBank] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [swiftCode, setSwiftCode] = useState("");
  const [swiftError, setSwiftError] = useState("");
  const [transitNumber, setTransitNumber] = useState("");
  const [iban, setIban] = useState("");
  const fileInputRef = useRef(null);
  const [stream, setStream] = useState(null);
  const videoRef = useRef(null);
  const [showCamera, setShowCamera] = useState(false);
  const [animateCamera, setAnimateCamera] = useState(false);
  const canvasRef = useRef(null);
  const [preview, setPreview] = useState("");
  const [uploadPic, setUploadPic] = useState("");
  const profilePicURL = useSelector((state) => state.user.userProfilePic);
  const profilePicDownloadUrl = useSelector(
    (state) => state.user.userProfilePicDownloadUrl
  );
  const [isModalOpenProfileEdit, setIsModalOpenProfileEdit] = useState(false);
  const [error, setError] = useState("");
  const [countryCodeProfile, setCountryCodeProfile] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [newCity, setNewCity] = useState("");
  const [newState, setNewState] = useState("");
  const [newAddress, setNewAddress] = useState("");
  const [newZipCode, setNewZipCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [focus, setFocus] = useState(false);
  const [selectedCode, setSelectedCode] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [newLastName, setNewLastName] = useState("");
  const [preselectedCity, setpreselectedCity] = useState({});
  const [preselectedState, setpreselectedState] = useState({});
  const [cityData, setCityData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [bsbError, setBsbError] = useState("");

  const [preselectedCountryCodeProfile, setpreselectedCountryCodeProfile] =
    useState({});
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const { routingNumber, routingError, handleRoutingChange, setRoutingNumber } =
    useRoutingNumberValidation();
  const [totalCountExternalBank, setTotalCountExternalBank] = useState(0);
  const [totalPagesExternalBank, setTotalPagesExternalBank] = useState(0);
  const [currentPageExternalBank, setCurrentPageExternalBank] = useState(1);
  const [externalbankTable, setExternalbankTable] = useState([]);
  const [showRecordsExternalBank, setShowRecordsExternalBank] = useState(10);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const StatusRef = useRef();
  const [isOpenEditCashAccountBank, setIsOpenEditCashAccountBank] =
    useState(false);
  const [bankTab, setBankTab] = useState("");

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const tabs = [
    { id: "extBank", label: "External Bank" },
    { id: "thpBank", label: "Third Party Bank" },
  ];
  const externalAccountHeaders = [
    { label: "Date", key: "" },
    { label: "Account Name", key: "" },
    { label: "Account Number/IBAN", key: "" },
    { label: "Account BSB", key: "" },
    { label: "Bank Name", key: "" },
    { label: "Other Details", key: "" },
    { label: "Bank Address", key: "" },
    { label: "Country Code", key: "" },
    { label: "Status", key: "" },
    { label: "Action", key: "" },
  ];
  const AllStatusFilters = [
    { value: null, label: "ALL" },
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
    { value: "pending", label: "Pending" },
  ];
  const europeanCountryCodes = new Set([
    "AL",
    "AD",
    "AM",
    "AT",
    "AZ",
    "BY",
    "BE",
    "BA",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "GE",
    "DE",
    "GR",
    "HU",
    "IS",
    "IE",
    "IT",
    "KZ",
    "LV",
    "LI",
    "LT",
    "LU",
    "MT",
    "MD",
    "MC",
    "ME",
    "NL",
    "MK",
    "NO",
    "PL",
    "PT",
    "RO",
    "RU",
    "SM",
    "RS",
    "SK",
    "SI",
    "ES",
    "SE",
    "CH",
    "TR",
    "UA",
    "GB",
    "VA",
  ]);
  const handleBsbChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setToBsb(numericValue);

    // Validation: must be 6 digits
    if (numericValue.length === 0) {
      setBsbError("BSB is required");
    } else if (numericValue.length !== 6) {
      setBsbError("BSB must be 6 digits");
    } else {
      setBsbError("");
    }
  };
  const handleTransitChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setTransitNumber(numericValue);

    // Validation: must be 5 digits
    if (numericValue.length === 0) {
      setTransitError("Transit number is required");
    } else if (numericValue.length !== 5) {
      setTransitError("Transit number must be 5 digits");
    } else {
      setTransitError("");
    }
  };
  const validateSwift = (value) => {
    const swiftRegex =
      /^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    return swiftRegex.test(value);
  };
  const handleSwiftChange = (e) => {
    const value = e.target.value.toUpperCase(); // optional: auto uppercase
    setSwiftCode(value);

    if (value && !validateSwift(value)) {
      setSwiftError("Invalid SWIFT/BIC format");
    } else {
      setSwiftError("");
    }
  };
  const handleshowRecordBank = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecordsExternalBank(parseInt(selectedOption.value));
    setCurrentPageExternalBank(1);
  };
  const getAllBanksDataAdmin = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/account/external-bank/list/external?limit=100&page=1&search=${searchQuery}`
      );
      if (
        response.status == 200 &&
        response.data &&
        response.data.bank_accounts.length > 0
      ) {
        setExternalbankTable(response.data.bank_accounts);
      } else {
        setExternalbankTable([]);
      }
    } catch (err) {
      setExternalbankTable([]);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const addThpBank = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let bodyData = {};
    let apiUrl = `${BASE_URL}/v1/merchant/dashboard/account/external-bank/add/external`;
    bodyData = {
      bank_name: toBank,
      account_number: toAccountNumber,
      account_bsb: toBsb,
      account_name: toAccountName,
      currency_id: toCurrency,
      address_line1: addressLine1,
      address_line2: addressLine2,
      address_line3: addressLine3,
      country_code: countryCode,
      swift_code: swiftCode,
      routing_number: routingNumber,
      institution_number: institutionNumber,
      transit_number: transitNumber,
      iban: iban,
      user_id: userId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleThirdPartyBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addThpBank();
        if (response.status == 201) {
          setisOpenEditCashAccount(false);
          getAllBanksDataAdmin();
          toastMessage = {
            message: "Bank added successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      userId,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
    ] // Dependencies
  );
  const togglePopupAddBankCashAccount = () => {
    clearAllFieldsBank();
    setIsOpenEditCashAccountBank(!isOpenEditCashAccountBank);
  };
  const handleEditClickProfile = () => {
    setIsModalOpenProfileEdit(true);
    setNewFirstName(profileData.first_name);
    setNewLastName(profileData.last_name);
    setNewEmail(profileData.email_address);
    setMobileNumber(profileData.mobile_number);
    setSelectedCode(profileData.country_code);

    if (addressData && addressData.country) {
      setpreselectedCountryCodeProfile({
        value: addressData.country.id,
        label: addressData.country.name,
      });
      setCountryCodeProfile(addressData.country.id);
    }

    if (addressData && addressData.city) {
      setpreselectedCity({
        value: addressData.city.id,
        label: addressData.city.name,
      });
      setNewCity(addressData.city.id);
    }

    if (addressData && addressData.state) {
      setpreselectedState({
        value: addressData.state.id,
        label: addressData.state.name,
      });
      setNewState(addressData.state.id);
    }

    if (addressData) {
      setNewZipCode(addressData.zip_code);
      setNewAddress(addressData.google_address);
    }
  };
  // Step 2: Function to check if a code is European
  function isEuropeanCountry(code) {
    return europeanCountryCodes.has(code.toUpperCase());
  }
  const handleEditClickBank = (e, rowData) => {
    setcurrentBank(rowData.id);
    setIsModalOpenBankEdit(true);

    setToAccountName(rowData.account_name);
    if (rowData.country_code == null) {
      setCountryCode("AU");
      setCountryCodeEdit("AU");
    } else {
      setCountryCode(rowData.country_code);
      setCountryCodeEdit(rowData.country_code);
    }
    setToAccountNumber(rowData.account_number);
    setToBank(rowData.bank_name);

    if (rowData.currency == null) {
      setpreselectedCurrency({
        value: 2,
        label: "AUD",
      });
      setToCurrency(2);
    } else {
      setpreselectedCurrency({
        value: rowData.currency.id,
        label: rowData.currency.name,
      });
      setToCurrency(rowData.currency.id);
    }

    setToBsb(rowData.account_bsb);
    setSwiftCode(rowData.swift_code);
    setRoutingNumber(rowData.routing_number);
    setTransitNumber(rowData.transit_number);
    setinstitutionNumber(rowData.institution_number);
    setIban(rowData.iban);
    setAddressLine1(rowData.address_line1);
    setAddressLine2(rowData.address_line2);
    setAddressLine3(rowData.address_line3);
  };
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const toggleConfirmPassword = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };
  const handleSelectCountryCodeProfile = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCodeProfile(selectedOption.value);
    setStateData([]);
    setCityData([]);
    setpreselectedCity({});
    setpreselectedState({});
  };
  const handleSelectCountryCode = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCode(selectedOption.value);
  };
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const handleProfileClick = () => {
    setIsModalOpenProfile(true);
  };
  const clearAllFieldsBank = () => {
    setToAccountName("");
    setpreselectedCurrency({ value: 2, label: "AUD" });
    setpreselectedCountryCode({ value: "AU", label: "Australia" });
    setAddressLine1("");
    setToAccountNumber("");
    setToBank("");
    setAddressLine2("");
    setToBsb("");
    setCountryCode("AU");
    setToCurrency(2);
    setAddressLine3("");
    setSwiftCode("");
    setRoutingNumber("");
    setTransitNumber("");
    setIban("");
    setinstitutionNumber("");
  };
  const handleSelectToCurrency = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setToCurrency(selectedOption.value);
  };
  const fileUploadNew = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/upload/profile-image`;
    const formData3 = new FormData();
    formData3.append("profile_image", uploadPic); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleUploadFile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await fileUploadNew();
        if (response.status == 200) {
          handleCloseCamera();
          dispatch(setUserProfilePic(response.data.profile_image_url));
          dispatch(
            setUserProfilePicDownloadUrl(
              response.data.profile_image_url_download
            )
          );
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [uploadPic] // Dependencies
  );
  const handleSelectCity = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setNewCity(selectedOption.value);
  };
  const handleSelectState = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setNewState(selectedOption.value);
  };
  const editProfile = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/profile/update/${profileData.id}`;
    const bodyData = {
      first_name: newFirstName,
      last_name: newLastName,
      country_code: selectedCode,
      mobile_number: mobileNumber,
      email_address: newEmail,
      type: customerType,
      address: {
        city_id: newCity,
        country_id: countryCodeProfile,
        state_id: newState,
        zip_code: newZipCode,
        google_address: newAddress,
      },
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleEditProfile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await editProfile();
        if (response.status == 200) {
          setIsModalOpenProfileEdit(false);
          getprofileData();
          toastMessage = {
            message: "Details updated successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      newFirstName,
      newLastName,
      selectedCode,
      mobileNumber,
      newEmail,
      customerType,
      newCity,
      countryCodeProfile,
      newState,
      newZipCode,
      newAddress,
    ] // Dependencies
  );
  const addBank = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/account/external-bank/add`;
    const bodyData = {
      bank_name: toBank,
      account_number: toAccountNumber,
      account_bsb: toBsb,
      account_name: toAccountName,
      currency_id: toCurrency,
      address_line1: addressLine1,
      address_line2: addressLine2,
      address_line3: addressLine3,
      country_code: countryCode,
      swift_code: swiftCode,
      routing_number: routingNumber,
      institution_number: institutionNumber,
      transit_number: transitNumber,
      iban: iban,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleChangeIban = (e) => {
    const value = e.target.value.toUpperCase(); // IBANs are uppercase
    setIban(value);
  };
  const handleAddBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addBank();
        if (response.status == 200) {
          setisOpenEditCashAccount(false);
          setisOpenEdit(false);
          getBankData();

          toastMessage = {
            message:
              "Bank added successfully. Please check your authenticator app to verify the request and proceed",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      userId,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
    ] // Dependencies
  );
  const editBank = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/account/external-bank/update/${currentBank}`;
    const bodyData = {
      bank_name: toBank,
      account_number: toAccountNumber,
      account_bsb: toBsb,
      account_name: toAccountName,
      currency_id: toCurrency,
      address_line1: addressLine1,
      address_line2: addressLine2,
      address_line3: addressLine3,
      country_code: countryCode,
      user_id: userId,
      swift_code: swiftCode,
      routing_number: routingNumber,
      institution_number: institutionNumber,
      transit_number: transitNumber,
      iban: iban,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  function setCountryCodeEdit(countryCode) {
    const match = countryCodeData.find((c) => c.value === countryCode);
    if (match) {
      setpreselectedCountryCode({
        value: match.value,
        label: match.label,
      });
    } else {
      // Optional: set a default if no match found
      setpreselectedCountryCode({
        value: "",
        label: "",
      });
    }
  }
  const handleEditClick = (rowData) => {
    setcurrentBank(rowData.id);
    setIsModalOpenBankEdit(true);

    setToAccountName(rowData.account_name);
    if (rowData.country_code == null) {
      setCountryCode("AU");
      setCountryCodeEdit("AU");
    } else {
      setCountryCode(rowData.country_code);
      setCountryCodeEdit(rowData.country_code);
    }
    setToAccountNumber(rowData.account_number);
    setToBank(rowData.bank_name);

    if (rowData.currency == null) {
      setpreselectedCurrency({
        value: 2,
        label: "AUD",
      });
      setToCurrency(2);
    } else {
      setpreselectedCurrency({
        value: rowData.currency.id,
        label: rowData.currency.name,
      });
      setToCurrency(rowData.currency.id);
    }
    setToBsb(rowData.account_bsb);
    setSwiftCode(rowData.swift_code);
    setRoutingNumber(rowData.routing_number);
    setTransitNumber(rowData.transit_number);
    setinstitutionNumber(rowData.institution_number);
    setIban(rowData.iban);
    setAddressLine1(rowData.address_line1);
    setAddressLine2(rowData.address_line2);
    setAddressLine3(rowData.address_line3);
  };
  const handleEditBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await editBank();
        if (response.status == 200) {
          setcurrentBank(null);
          setIsModalOpenBankEdit(false);
          if (bankTab == "extBank") {
            getBankData();
          }
          if (bankTab == "thpBank") {
            getAllBanksDataAdmin();
          }
          toastMessage = {
            message: "Bank edited successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      currentBank,
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      userId,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
    ] // Dependencies
  );
  const getAllCountryCode = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/country-codes`);

      if (response.status == 200) {
        let AllAccount = [];
        Object.entries(response.data).forEach(([key, value]) => {
          AllAccount.push({
            value: key,
            label: value,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setCountryCodeData([]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllCountries = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/countries?size=1000`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.countries.forEach((item) => {
          AllAccount.push({
            value: item.id,
            label: item.name,
          });
        });

        setCountryData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setCountryData([]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, "error");
    } finally {
    }
  };
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const getCities = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 20; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/cities/${countryCodeProfile}?page=${page}&size=${size}&search=${
          searchTerm || ""
        }`
      );

      if (response.status === 200) {
        const items = response.data.cities.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.cities.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, "error");
      return { items: [], hasMore: false };
    }
  };
  const getStates = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 20; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/states/${countryCodeProfile}?page=${page}&size=${size}&search=${
          searchTerm || ""
        }`
      );

      if (response.status === 200) {
        const items = response.data.states.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.states.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, "error");
      return { items: [], hasMore: false };
    }
  };

  const getAllStates = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/user/states/${countryCodeProfile}?size=200000`
      );

      if (response.status == 200) {
        let AllAccount = [];
        response.data.states.forEach((item) => {
          AllAccount.push({
            value: item.id,
            label: item.name,
          });
        });

        setStateData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setStateData([]);
      setpreselectedState({});
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(`/v1/account/currencies`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
          });
        });

        setCurrencyData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const toggleCurrentPassword = () => {
    setShowCurrentPassword((prevState) => !prevState);
  };
  const toggleNewPassword = () => {
    setShowNewPassword((prevState) => !prevState);
  };
  const togglePopupAddTransactionCashAccount = () => {
    clearAllFieldsBank();
    setisOpenEditCashAccount(!isOpenEditCashAccount);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getprofileData = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/profile/me?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setprofileData(response.data.my_profile);
        setAccountAnalytics(response.data.portfolio);
        setAddressData(response.data.address);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setprofileData({});
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setprofileData({});
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const getBankData = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/account/external-bank/list?limit=100&search=${searchQuery}`
      );

      if (response.status == 200) {
        setBankdata(response.data.banks);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setBankdata([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const getAccountData = async () => {
    setAccountData({
      no_of_active_accounts: 0,
      no_of_archieved_accounts: 0,
      active_accounts: {
        my_investments: 0,
      },
      archieved_accounts: {},
    });
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/profile/accounts`
      );

      if (response.status == 200) {
        setAccountData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAccountData({});
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };

  useEffect(() => {
    if (filter === "profile") {
      getprofileData();
      getAllCountries();
    }
    if (filter === "banks") {
      getAllCountryCode();
      getAllCurrency();
    }
    if (filter === "accounts") {
      getAccountData();
    }
  }, [filter, bankTab]);
  useEffect(() => {
    if (filter === "banks") {
      if (bankTab == "extBank") {
        getBankData();
      }
      if (bankTab == "thpBank") {
        getAllBanksDataAdmin();
      }
    }
  }, [filter, bankTab, searchQuery]);

  const UpdatePassword = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/profile/change-password`;
    const bodyData = {
      old_password: currentpassword,
      new_password: newPassword,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ["image/png", "image/jpeg"];
    const maxSizeMB = 10;

    if (!validTypes.includes(file.type)) {
      showToast("Please upload an image in PNG or JPEG format.", "error");
      return;
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
      showToast("File size must be less than 10MB.", "error");
      return;
    }
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setPreview(imageUrl);
      setUploadPic(file);
    }
  };
  const handleUpdatePassword = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdatePassword();

        if (response.status == 200) {
          togglePopupEdit();
          toastMessage = {
            message: "Password Updated successfully!",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [newPassword, currentpassword] // Dependencies
  );
  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr);

    const pad = (num) => String(num).padStart(2, "0");

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}/${month}/${year}`;
  };
  const startCamera = async () => {
    setPreview("");
    setUploadPic(null);
    setShowCamera(true);

    setTimeout(() => setAnimateCamera(true), 10); // trigger fade-in animation
    try {
      const newStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      setStream(newStream);
    } catch (err) {
      console.error("Camera access error:", err);
    }
  };
  const handleTakeSnap = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);
    const dataUrl = canvas.toDataURL("image/png");
    setPreview(dataUrl);
    fetch(dataUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], "photo.png", { type: "image/png" });
        setUploadPic(file); // now you can send this file to API
      });
    // cleanup
    //handleCloseCamera();
  };
  const handleCloseCamera = () => {
    setAnimateCamera(false); // start fade-out
    setTimeout(() => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        setStream(null);
      }
      setShowCamera(false); // hide modal after animation
    }, 300); // match duration-300
  };
  // assign stream to video after it's rendered
  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
      videoRef.current.play();
    }
  }, [stream]);
  return (
    <div className="w-full">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="pt-4 text-xs overflow-x-auto  flex-wrap items-center">
        <div className="flex mb-2 ">
          <button
            onClick={() => setFilter("profile")}
            className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
              filter === "profile"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Profile
          </button>
          <button
            onClick={() => {
              setFilter("banks");
              setBankTab("extBank");
            }}
            className={`lg:px-4 px-2 py-2 rounded-r-xl ${
              filter === "banks" ? "bg-black text-white" : "bg-white text-black"
            }`}
          >
            Banks
          </button>
          {/* <button
            onClick={() => setFilter("accounts")}
            className={`px-4 py-2 rounded-r-xl ${
              filter === "accounts"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Accounts
          </button> */}
        </div>
      </div>
      {/* Summary Cards */}
      {isLoading ? (
        <div className="shimmer-container-list mb-4 ">
          {/* Creating 5 rows of shimmer effect */}
          {[...Array(2)].map((_, rowIndex) => (
            <div key={rowIndex} className="shimmer-row-list">
              {/* Creating 7 cells in each row for shimmer */}
              {[...Array(2)].map((_, colIndex) => (
                <div key={colIndex} className="shimmer-cell-list h-20">
                  <div className="shimmer-loader"></div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <div>
          {/* {filter === "accounts" && (
            <CustomCardSlider
              componentName="customer-details"
              cardData={cardDatanew}
            />
          )} */}
        </div>
      )}

      {filter == "profile" && (
        <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            {/* Header Section */}
            <div className="flex w-full  flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-100">
              <div className="flex items-center mb-2 md:mb-0">
                <img
                  src="/profile-circle-black.svg"
                  alt="Company Logo"
                  className="mr-3 w-6 h-6"
                />
                <span className="font-medium lg:text-xl text-sm">Profile</span>
              </div>
              <p className="text-sm">
                <span className="font-medium text-labelLightColour">
                  Member since:{" "}
                </span>
                <span className="font-medium text-black">
                  {formatDateTime(profileData.created_at)}
                </span>
                <button
                  onClick={() => handleEditClickProfile()}
                  className="  right-4 px-3 rounded-md text-sm transition-colors duration-200"
                >
                  <img
                    src="/edit-details.svg" // Replace with the actual path to your edit icon
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </button>
              </p>
            </div>
            {isModalOpenProfileEdit && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                  {/* Modal Header */}
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Edit Personal Details
                      </h2>
                      <div className="flex justify-end">
                        <img
                          onClick={() => {
                            setIsModalOpenProfileEdit(false);
                          }}
                          src="/add.svg"
                          alt="Add"
                          className="w-10 h-10 cursor-pointer"
                        />
                      </div>
                    </div>
                    <div className="grid px-4 grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Left Column */}
                      <div className="space-y-4 pt-4 px-4">
                        {/* Code */}
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            First Name
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newFirstName}
                            onChange={(e) => setNewFirstName(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="John"
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Last Name
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newLastName}
                            onChange={(e) => setNewLastName(e.target.value)}
                            className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Doe"
                          />
                        </div>
                      </div>

                      {/* Center Column with Border */}
                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l border-gray-300 px-4">
                        <div className="mb-4">
                          <label
                            htmlFor="mobileNumber"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Mobile Number
                          </label>
                          <div className="flex  items-center">
                            <select
                              value={selectedCode}
                              onChange={handleCodeChange}
                              onFocus={() => setFocus(true)}
                              onBlur={() => setFocus(false)}
                              className={` text-code font-medium input-field-mobilecode rounded-md px-2  ${
                                focus
                                  ? "border-black border-2"
                                  : "border-gray-300 border"
                              } border-r-0 leading-tight focus:outline-none `}
                              placeholder="AU+61"
                            >
                              {countries.map((country) => (
                                <option
                                  key={country.code}
                                  value={country.dialCode}
                                >
                                  {country.code} {country.dialCode}
                                </option>
                              ))}
                            </select>
                            <input
                              type="tel"
                              id="mobileNumber"
                              value={mobileNumber}
                              onFocus={() => setFocus(true)}
                              onBlur={() => setFocus(false)}
                              onChange={(e) => setMobileNumber(e.target.value)}
                              placeholder="Mobile Number"
                              className={`border  text-black text-base font-medium input-field-mobile px-2 ${
                                focus
                                  ? "border-black border-2"
                                  : "border-gray-300 border"
                              } rounded-md focus:outline-none w-full border-l-0 appearance-none`}
                            />
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Email
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newEmail}
                            onChange={(e) => setNewEmail(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Your Email"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                      <h1 className="text-md font-medium mb-2 text-center">
                        Location Details
                      </h1>
                    </div>{" "}
                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                      {/* Left Column */}
                      <div className="space-y-4 pt-4 px-4">
                        <div className="">
                          <Dropdown
                            label="Select Country"
                            options={countryData}
                            search={true}
                            preselectedValue={preselectedCountryCodeProfile}
                            onSelect={handleSelectCountryCodeProfile}
                            colorLabel=""
                          />
                        </div>
                        <div>
                          <CustomDropdownWithFetch
                            label="Select City"
                            options={cityData}
                            search={true}
                            preselectedValue={preselectedCity}
                            onSelect={handleSelectCity}
                            colorLabel=""
                            fetchOptions={getCities} // <-- pass fetch function, not options
                          />
                          {/* <input
                            id="finInstituition"
                            type="text"
                            value={newCity}
                            onChange={(e) => setNewCity(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Sydney..."
                          /> */}
                        </div>
                      </div>

                      {/* Center Column with Border */}
                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        <div>
                          <CustomDropdownWithFetch
                            label="Select State"
                            options={stateData}
                            search={true}
                            preselectedValue={preselectedState}
                            onSelect={handleSelectState}
                            colorLabel=""
                            fetchOptions={getStates} // <-- pass fetch function, not options
                          />
                          {/* <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            State
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newState}
                            onChange={(e) => setNewState(e.target.value)}
                            className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="NSW"
                          /> */}
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Zip Code
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newZipCode}
                            onChange={(e) => setNewZipCode(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Apartment unit 2 etc..."
                          />
                        </div>
                      </div>

                      {/* Right Column */}
                      <div className="space-y-4 px-4 pt-4">
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Address
                          </label>{" "}
                          <textarea
                            id="finInstituition"
                            type="text"
                            value={newAddress}
                            onChange={(e) => setNewAddress(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Apartment unit 2 etc..."
                          />
                          {/* <AddressAutocomplete onSelect={(addr) => setSelectedAddress(addr)} />

      {selectedAddress && (
        <div className="mt-4 p-4 border rounded">
          <p><strong>Full:</strong> {selectedAddress.full}</p>
          <p><strong>Street:</strong> {selectedAddress.street}</p>
          <p><strong>City:</strong> {selectedAddress.city}</p>
          <p><strong>State:</strong> {selectedAddress.state}</p>
          <p><strong>ZIP:</strong> {selectedAddress.zip}</p>
          <p><strong>Country:</strong> {selectedAddress.country}</p>
        </div>
      )} */}
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                      <button
                        onClick={() => {
                          setIsModalOpenProfileEdit(false);
                        }}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (!validateEmail(newEmail)) {
                            showToast("Enter the valid email", "error");
                            return;
                          }
                          if (
                            !validator.isMobilePhone(
                              selectedCode + mobileNumber,
                              "any"
                            )
                          ) {
                            console.log("country code " + selectedCode);
                            console.log("mobile number is " + mobileNumber);
                            console.log(
                              validator.isMobilePhone(
                                selectedCode + mobileNumber,
                                "any"
                              )
                            );
                            showToast(
                              "Please enter valid mobile number",
                              "error"
                            );
                            return;
                          }
                          if (
                            !newFirstName ||
                            !newLastName ||
                            !newEmail ||
                            !selectedCode ||
                            !mobileNumber ||
                            !newCity ||
                            !newState ||
                            !newZipCode ||
                            !newAddress ||
                            !countryCodeProfile
                          ) {
                            showToast("Please Add all fields", "error");
                            return;
                          }
                          setLoading(true);
                          handleEditProfile(e);
                        }}
                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                      >
                        Update Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Profile Section */}
            <div className="flex w-full flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
              {/* Profile Picture */}
              <div className="relative flex flex-col sm:flex-row items-center gap-4 mb-4 lg:mb-0">
                {/* Profile Picture */}
                <div className="relative">
                  <img
                    src={profilePicURL}
                    alt={`${profileData.first_name}`}
                    className="w-14 h-14 rounded-full object-cover"
                  />
                  {profileData.status === "active" && (
                    <div className="absolute top-2 left-12 w-3 h-3 bg-[#75E380] rounded-full"></div>
                  )}
                  {profileData.status === "rejected" && (
                    <div className="absolute top-2 left-12 w-3 h-3 bg-[#FF5050] rounded-full"></div>
                  )}
                  <label
                    htmlFor="investmentManagerFees"
                    className="mt-2 text-xs block text-center"
                  >
                    <span className="text-[#A6A6A6]">Client No:</span>
                  </label>
                  <p className="text-black text-sm text-center">
                    {profileData.client_id}
                  </p>
                </div>

                {/* Buttons */}
                <div className="flex flex-col space-y-2 mb-4">
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleProfileClick();
                    }}
                    className="bg-white text-black border-black border-2 text-xs px-3 py-1 rounded-full whitespace-nowrap"
                  >
                    View Picture
                  </button>
                  <button
                    onClick={startCamera}
                    className="bg-black text-white text-xs px-3 py-1 rounded-full flex items-center justify-center gap-2 whitespace-nowrap"
                  >
                    <img
                      src="/camera-black.svg"
                      alt="Camera Icon"
                      className="w-4 h-4"
                    />
                    Edit Picture
                  </button>
                </div>
              </div>

              {/* Profile Details */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full ">
                {/* Column 1 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="refId"
                    className="mb-1 text-xs text-[#A6A6A6]"
                  >
                    Status
                  </label>
                  <span className="text-sm">{profileData.status}</span>
                  {profileData.type !== "Corporate" && (
                    <>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          First Name
                        </label>
                        <div className="text-sm">{profileData.first_name}</div>
                      </div>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          Last Name
                        </label>
                        <div className="text-sm">{profileData.last_name}</div>
                      </div>
                    </>
                  )}

                  {profileData.type === "Corporate" && (
                    <>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          Company Name
                        </label>
                        <div className="text-sm">
                          {profileData.first_name} {profileData.last_name}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Column 2 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 text-xs"
                  >
                    <span className="text-[#A6A6A6]">Phone</span>
                  </label>
                  <div className="text-sm">
                    {profileData.country_code}
                    {profileData.mobile_number}
                  </div>
                  {profileData.type !== "Corporate" && (
                    <>
                      <label
                        htmlFor="investmentManagerFees"
                        className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                      >
                        Email
                      </label>
                      <span className="text-sm">
                        {profileData.email_address}
                      </span>
                    </>
                  )}
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                  >
                    Type
                  </label>
                  <div className="text-sm">{profileData.type}</div>
                </div>

                {/* Column 3 */}
                {profileData.type !== "Corporate" && (
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 text-xs"
                    >
                      <span className="text-[#A6A6A6]">Password</span>
                    </label>
                    <div className="text-sm">{profileData.password}</div>
                    <button
                      onClick={togglePopupEdit}
                      className="mt-4 py-3 w-40 bg-black text-white text-sm rounded-md hover:bg-gray-800"
                    >
                      Change Password
                    </button>
                  </div>
                )}
                {isOpenEdit && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[700px] p-6">
                      {/* Modal Header */}
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Change Password
                        </h2>
                        <button onClick={togglePopupEdit}>
                          <img
                            src="/add.svg"
                            alt="Close"
                            className="w-10 h-10"
                          />
                        </button>
                      </div>

                      {/* Modal Body */}
                      <div className="grid grid-cols-1 gap-6 items-center">
                        <div className="space-y-4 mx-auto ">
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              Current password
                            </label>
                            <input
                              type={showcurrentPassword ? "text" : "password"}
                              value={currentpassword}
                              required={true}
                              id="currentpassword"
                              onChange={(e) =>
                                setcurrentPassword(e.target.value)
                              }
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleCurrentPassword}
                              className="absolute right-3 set-top"
                            >
                              {" "}
                              {showcurrentPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              New password
                            </label>
                            <input
                              type={shownewPassword ? "text" : "password"}
                              value={newPassword}
                              required={true}
                              id="newpassword"
                              onChange={(e) => setnewPassword(e.target.value)}
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleNewPassword}
                              className="absolute right-3 set-top"
                            >
                              {" "}
                              {shownewPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block color-test dark:text-gray-300 font-normal color-test text-md mb-1"
                            >
                              Repeat password
                            </label>
                            <input
                              type={showconfirmPassword ? "text" : "password"}
                              value={confirmPassword}
                              required={true}
                              id="confirmpassword"
                              onChange={(e) =>
                                setconfirmPassword(e.target.value)
                              }
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleConfirmPassword}
                              className="absolute right-3 set-top"
                            >
                              {" "}
                              {showconfirmPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Modal Footer */}
                      <div className="flex justify-center space-x-4 mt-6">
                        <button
                          onClick={togglePopupEdit}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (newPassword.length < 8) {
                              showToast(
                                "Password must have At least 8 characters",
                                "error"
                              );
                              return;
                            }
                            if (!/(?=.*[0-9])/.test(newPassword)) {
                              showToast(
                                "Password must have At least 1 number",
                                "error"
                              );

                              return;
                            }
                            if (
                              !/(?=.*[!@#$%^&*()_+={}\[\]|:;"'<>,.?/`~\\/-])/.test(
                                newPassword
                              )
                            ) {
                              showToast(
                                "Password must have At least 1 special character",
                                "error"
                              );

                              return;
                            }
                            if (
                              !(
                                /(?=.*[a-z])/.test(newPassword) &&
                                /(?=.*[A-Z])/.test(newPassword)
                              )
                            ) {
                              showToast(
                                "Password must have Both upper and lower case characters",
                                "error"
                              );

                              return;
                            }
                            if (newPassword !== confirmPassword) {
                              showToast(
                                "Confirm password should be same as password",
                                "error"
                              );

                              return;
                            }
                            if (newPassword === currentpassword) {
                              showToast(
                                "New password should be different from current password",
                                "error"
                              );
                              return;
                            }
                            setLoading(true);
                            handleUpdatePassword(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {showCamera && (
            <div
              className={`fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out ${
                animateCamera ? "opacity-100" : "opacity-0"
              }`}
            >
              <div
                className={`relative transform transition-transform duration-300 ease-in-out bg-white rounded-xl p-4 w-full max-w-md flex flex-col items-center ${
                  animateCamera ? "scale-100" : "scale-90"
                }`}
              >
                {/* Preview or Live Camera */}
                {preview === "" ? (
                  <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    className="w-full h-auto rounded shadow-lg"
                  />
                ) : (
                  <div className="relative w-full">
                    <img
                      src={preview}
                      alt="Avatar"
                      className="w-full h-auto rounded shadow-lg"
                    />
                    <button
                      onClick={() => {
                        startCamera();
                      }}
                      className="absolute top-2 right-2 bg-white hover:bg-gray-100 p-1 rounded-full shadow-md transition"
                      aria-label="Remove preview"
                    >
                      <img src="/trash.svg" alt="Delete" className="w-4 h-4" />
                    </button>
                  </div>
                )}

                {/* Action Buttons */}
                <div className="flex flex-wrap justify-center gap-4 mt-4">
                  <button
                    onClick={handleCloseCamera}
                    className="bg-white text-black border-black border-2 text-sm px-4 py-2 rounded-full"
                  >
                    Cancel
                  </button>
                  {preview === "" && (
                    <>
                      <button
                        onClick={handleTakeSnap}
                        className="bg-black text-white text-sm px-4 py-2 rounded-full"
                      >
                        Capture Photo
                      </button>
                      <button
                        onClick={handleUploadClick}
                        className="bg-black text-white text-sm px-4 py-2 rounded-full"
                      >
                        Upload From Device
                      </button>
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                      />
                    </>
                  )}
                  {preview !== "" && (
                    <>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setLoading(true);
                          handleUploadFile(e);
                        }}
                        className="bg-black text-white text-sm px-4 py-2 rounded-full"
                      >
                        Upload Photo
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          <canvas ref={canvasRef} className="hidden" />
          {isModalOpenProfile && profilePicURL && (
            <DocumentPreview
              fileUrl={profilePicDownloadUrl}
              fileName={profilePicURL.split("/").pop().split("?")[0]}
              onClose={() => setIsModalOpenProfile(false)}
            />
          )}
          <div className="pt-4  lg:flex mb-4 lg:space-x-4 gap-4">
            {/* Left Section: Two Cards */}
            <div className="flex flex-col flex-[1.5] space-y-4">
              {/* Total Deposit Card */}
              <div className="bg-white p-6 rounded-lg shadow-lg w-full flex-1">
                <div className="flex justify-between border-b  items-start">
                  <div className="flex items-center pb-2 space-x-4">
                    <img
                      src="/folder-2.svg"
                      alt="Account Icon"
                      className="w-5 h-5"
                    />
                    <h3 className="text-black text-lg font-medium">
                      Accounts Analytics
                    </h3>
                  </div>
                </div>
                {accountAnalytics && (
                  <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-0 sm:gap-6">
                    <div className="text-sm text-gray-500 flex-1  sm:border-b-0 md:border-r sm:border-r-0 border-gray-300 pr-4 pt-4">
                      <div className="mb-4">
                        <p className="text-xs text-[#A6A6A6] mb-1">Portfolio</p>
                        <div className="font-medium text-black">
                          $
                          {accountAnalytics?.total_portfolio
                            ? accountAnalytics.total_portfolio
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </div>
                      </div>
                      <div className="mb-4">
                        <p className="text-xs text-[#A6A6A6] mb-1">Accounts</p>
                        <div className="font-medium text-black">
                          {accountAnalytics.no_of_cash_accounts}
                        </div>
                      </div>
                      <div>
                        <p className="text-xs text-[#A6A6A6] mb-1">Deposit</p>
                        <div className="font-medium text-black">
                          $
                          {accountAnalytics?.total_deposit
                            ? accountAnalytics.total_deposit
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </div>
                      </div>
                    </div>

                    {/* Withdrawal Section */}
                    <div className="text-sm text-gray-500 flex-1 pr-4 pt-4 flex sm:items-start">
                      <div className="self-start">
                        <p className="text-xs text-[#A6A6A6] mb-1">
                          Withdrawal
                        </p>
                        <div className="font-medium text-black">
                          $
                          {accountAnalytics?.total_withdrawal
                            ? accountAnalytics.total_withdrawal
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Right Section: Account Balance */}
            <div className="bg-white p-6 rounded-lg shadow-lg w-full lg:flex-[1.5] lg:mt-0 mt-4  border border-gray-200 flex-1">
              <div className="flex justify-between border-b  items-start">
                <div className="flex items-center pb-2 space-x-4">
                  <img
                    src="/map.svg"
                    alt="Account Icon"
                    className="w-5 h-5 rounded-full"
                  />
                  <h3 className="text-black text-lg font-medium">Location</h3>
                </div>
              </div>
              {addressData != null && (
                <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-0 sm:gap-6">
                  <div className="text-sm text-gray-500 flex-1  sm:border-b-0 md:border-r sm:border-r-0 border-gray-300 pr-4 pt-4">
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6] mb-1">Country</p>
                      <div className="font-medium text-black">
                        {addressData?.country?.name || "N/A"}
                      </div>
                    </div>
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6] mb-1">Zip Code</p>
                      <div className="font-medium text-black">
                        {addressData?.zip_code || "N/A"}
                      </div>
                    </div>
                    <div>
                      <p className="text-xs text-[#A6A6A6] mb-1">State</p>
                      <div className="font-medium text-black">
                        {addressData?.state?.name || "N/A"}
                      </div>
                    </div>
                  </div>

                  {/* Withdrawal Section */}
                  <div className="text-sm text-gray-500 flex-1 pr-4 pt-4">
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6]">Address</p>
                      <div className="font-medium text-black">
                        {addressData?.google_address || "N/A"}
                      </div>
                    </div>
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6]">City</p>
                      <div className="font-medium text-black">
                        {addressData?.city?.name || "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {filter == "banks" && (
        <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
          <div className="relative w-full border-b border-gray-200 mb-6">
            <div className="flex justify-start space-x-6 md:space-x-10 text-sm md:text-base font-medium">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => {
                    setSearchQuery("");
                    setBankTab(tab.id);
                  }}
                  className={`relative pb-3 transition-colors duration-300 ${
                    bankTab === tab.id
                      ? "text-black"
                      : "text-gray-500 hover:text-black"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Animated underline */}
            <div
              className={`absolute bottom-0 h-[2px] bg-black transition-all duration-300 ease-in-out`}
              style={{
                width: bankTab === "extBank" ? "120px" : "160px", // match label width
                transform:
                  bankTab === "extBank"
                    ? "translateX(0%)"
                    : "translateX(140px)", // adjust based on spacing
              }}
            />
          </div>
          {bankTab === "extBank" && (
            <div className="w-full p-4 bg-white rounded-lg shadow-lg">
              {/* Header Section */}
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 pb-5 border-gray-100">
                {/* Left: Title */}
                <div className="flex items-center">
                  <img
                    src="/cards.svg"
                    alt="Company Logo"
                    className="mr-2 w-6 h-6"
                  />
                  <span className="font-medium lg:text-xl text-sm">
                    Linked External Bank Accounts
                  </span>
                </div>

                {/* Right: Count and Button */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full md:w-auto justify-end">
                  <div className="flex items-center">
                    <div className="relative">
                      <input
                        type="text"
                        className="p-2 pl-8 border rounded-xl"
                        placeholder="Search Bank.."
                        value={searchQuery}
                        onChange={(e) => {
                          setSearchQuery(e.target.value);
                        }}
                      />
                      <span className="absolute left-2 top-3 text-gray-500">
                        {" "}
                        <img
                          src="/search-normal.svg"
                          alt="Company Logo"
                          className="mr-2"
                        />
                      </span>
                    </div>
                  </div>
                  <p className="text-sm">
                    <span className="font-medium text-labelLightColour">
                      No of Bank Accounts:{" "}
                    </span>
                    <span className="font-medium text-black">
                      {bankdata.length}
                    </span>
                  </p>
                  <button
                    onClick={togglePopupAddTransactionCashAccount}
                    className="flex items-center text-[#005A9C] bg-white border border-[#005A9C] py-2 px-3 sm:px-4 rounded-xl w-full sm:w-auto justify-center"
                  >
                    <img src="/Plus.svg" alt="Add Icon" className="mr-2 ml-2" />
                    <span className="inline">Add Bank</span>
                  </button>
                </div>
              </div>

              {isOpenEditCashAccount && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div>
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Add New External Bank
                        </h2>
                        <div className="flex justify-end">
                          <img
                            onClick={togglePopupAddTransactionCashAccount}
                            src="/add.svg"
                            alt="Add"
                            className="w-10 h-10 cursor-pointer"
                          />
                        </div>
                      </div>
                      <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                        {/* Left Column */}
                        <div className="space-y-4 pt-4 px-4">
                          {/* Code */}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Account Name
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={toAccountName}
                              onChange={(e) => setToAccountName(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="John Doe"
                            />
                          </div>
                          {countryCode != "AE" &&
                            countryCode != "GB" &&
                            !isEuropeanCountry(countryCode) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Account Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toAccountNumber}
                                  onChange={(e) =>
                                    setToAccountNumber(e.target.value)
                                  }
                                  className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="0291288"
                                />
                              </div>
                            )}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Bank Name
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={toBank}
                              onChange={(e) => setToBank(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Bank Name"
                            />
                          </div>
                        </div>

                        {/* Center Column with Border */}
                        <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                          <div className="">
                            <Dropdown
                              label="Select Country"
                              options={countryCodeData}
                              search={true}
                              preselectedValue={preselectedCountryCode}
                              onSelect={handleSelectCountryCode}
                              colorLabel=""
                            />
                          </div>
                          <div className="">
                            <Dropdown
                              label="Currency"
                              options={currencyData}
                              search={true}
                              preselectedValue={preselectedcashCurrency}
                              onSelect={handleSelectToCurrency}
                              colorLabel=""
                            />
                          </div>
                          {countryCode == "AU" && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                BSB
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBsb}
                                maxLength={6}
                                onChange={(e) =>
                                  handleBsbChange(e.target.value)
                                }
                                className={`${
                                  bsbError
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {bsbError && (
                                <p className="text-red-600 text-xs mt-1">
                                  {bsbError}
                                </p>
                              )}
                            </div>
                          )}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Swift/BIC code
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={swiftCode}
                              onChange={handleSwiftChange}
                              className={`${
                                swiftError&& countryCode != "AU" 
                                  ? "border-red-300 "
                                  : "border-gray-300 "
                              }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                              placeholder="000000"
                            />
                            {swiftError&& countryCode != "AU"  && (
                              <p className="text-red-500 text-xs mt-1">
                                {swiftError}
                              </p>
                            )}
                          </div>
                          {countryCode == "US" && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Routing Number (ABA)
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={routingNumber}
                                maxLength={9}
                                onChange={(e) =>
                                  handleRoutingChange(e.target.value)
                                }
                                className={`${
                                  routingError
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000000"
                              />
                              {routingError && (
                                <p className="text-red-600 text-sm mt-1">
                                  {routingError}
                                </p>
                              )}
                            </div>
                          )}
                          {countryCode == "CA" && (
                            <>
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Transit Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={transitNumber}
                                  maxLength={5}
                                  onChange={(e) =>
                                    handleTransitChange(e.target.value)
                                  }
                                  className={`${
                                    transitError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="00000"
                                />
                                {transitError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {transitError}
                                  </p>
                                )}
                              </div>
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Institution Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={institutionNumber}
                                  onChange={(e) =>
                                    setinstitutionNumber(e.target.value)
                                  }
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                              </div>
                            </>
                          )}
                          {(countryCode == "AE" ||
                            countryCode == "GB" ||
                            isEuropeanCountry(countryCode)) && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                IBAN
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={iban}
                                onChange={handleChangeIban}
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="000000"
                              />
                              {error && (
                                <p className="text-red-500 text-sm mt-1">
                                  {error}
                                </p>
                              )}
                            </div>
                          )}
                        </div>

                        {/* Right Column */}
                        <div className="space-y-4 px-4 pt-4">
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 1
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine1}
                              onChange={(e) => setAddressLine1(e.target.value)}
                              className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Street address"
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 2
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine2}
                              onChange={(e) => setAddressLine2(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Apartment, unit etc."
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 3
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine3}
                              onChange={(e) => setAddressLine3(e.target.value)}
                              className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="City, Country etc."
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                        <button
                          onClick={togglePopupAddTransactionCashAccount}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (countryCode == "AU" && (!toBsb || bsbError)) {
                              showToast("Please enter a valid BSB", "error");
                              return;
                            }
                            if (
                              countryCode == "US" &&
                              (!routingNumber || routingError)
                            ) {
                              showToast(
                                "Please enter a valid routing number",
                                "error"
                              );
                              return;
                            }
                            if (
                              (countryCode == "AE" ||
                                countryCode == "GB" ||
                                isEuropeanCountry(countryCode)) &&
                              !iban
                            ) {
                              showToast("Please enter iban", "error");
                              return;
                            }
                            if (error) {
                              showToast("Please enter valid iban", "error");
                              return;
                            }
                            if (
                              countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) &&
                              !toAccountNumber
                            ) {
                              showToast("Please enter account number", "error");
                              return;
                            }
                            if (
                              countryCode == "CA" &&
                              (!transitNumber || transitError)
                            ) {
                              showToast(
                                "Please enter a valid transit number",
                                "error"
                              );
                              return;
                            }
                            if (countryCode == "CA" && !institutionNumber) {
                              showToast(
                                "Please enter institution number",
                                "error"
                              );
                              return;
                            }
                            if (countryCode != "AU" &&(!swiftCode || swiftError)) {
                              showToast(
                                "Please enter a valid swift code/BIC code",
                                "error"
                              );
                              return;
                            }
                            if (
                              !toAccountName ||
                              !toCurrency ||
                              !addressLine1 ||
                              !addressLine2 ||
                              !addressLine3 ||
                              !countryCode ||
                              !toBank
                            ) {
                              showToast("Please Add all fields", "error");
                              return;
                            }
                            setLoading(true);
                            handleAddBank(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Add Bank
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isModalOpenBankEdit && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div>
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Edit External Bank
                        </h2>
                        <div className="flex justify-end">
                          <img
                            onClick={() => {
                              setcurrentBank(null);
                              setIsModalOpenBankEdit(false);
                            }}
                            src="/add.svg"
                            alt="Add"
                            className="w-10 h-10 cursor-pointer"
                          />
                        </div>
                      </div>
                      <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                        {/* Left Column */}
                        <div className="space-y-4 pt-4 px-4">
                          {/* Code */}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Account Name
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={toAccountName}
                              onChange={(e) => setToAccountName(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="John Doe"
                            />
                          </div>
                          {countryCode != "AE" &&
                            countryCode != "GB" &&
                            !isEuropeanCountry(countryCode) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Account Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toAccountNumber}
                                  onChange={(e) =>
                                    setToAccountNumber(e.target.value)
                                  }
                                  className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="0291288"
                                />
                              </div>
                            )}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Bank Name
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={toBank}
                              onChange={(e) => setToBank(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Bank Name"
                            />
                          </div>
                        </div>

                        {/* Center Column with Border */}
                        <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                          <div className="">
                            <Dropdown
                              label="Select Country"
                              options={countryCodeData}
                              search={true}
                              preselectedValue={preselectedCountryCode}
                              onSelect={handleSelectCountryCode}
                              colorLabel=""
                            />
                          </div>
                          <div className="">
                            <Dropdown
                              label="Currency"
                              options={currencyData}
                              search={true}
                              preselectedValue={preselectedcashCurrency}
                              onSelect={handleSelectToCurrency}
                              colorLabel=""
                            />
                          </div>
                          {countryCode == "AU" && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                BSB
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBsb}
                                maxLength={6}
                                onChange={(e) =>
                                  handleBsbChange(e.target.value)
                                }
                                className={`${
                                  bsbError
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {bsbError && (
                                <p className="text-red-600 text-xs mt-1">
                                  {bsbError}
                                </p>
                              )}
                            </div>
                          )}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Swift/BIC code
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={swiftCode}
                              onChange={handleSwiftChange}
                              className={`${
                                swiftError&& countryCode != "AU" 
                                  ? "border-red-300 "
                                  : "border-gray-300 "
                              }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                              placeholder="000000"
                            />
                            {swiftError && countryCode != "AU" && (
                              <p className="text-red-500 text-xs mt-1">
                                {swiftError}
                              </p>
                            )}
                          </div>
                          {countryCode == "US" && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Routing Number (ABA)
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={routingNumber}
                                maxLength={9}
                                onChange={(e) =>
                                  handleRoutingChange(e.target.value)
                                }
                                className={`${
                                  routingError
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000000"
                              />
                              {routingError && (
                                <p className="text-red-600 text-sm mt-1">
                                  {routingError}
                                </p>
                              )}
                            </div>
                          )}
                          {countryCode == "CA" && (
                            <>
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Transit Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={transitNumber}
                                  maxLength={5}
                                  onChange={(e) =>
                                    handleTransitChange(e.target.value)
                                  }
                                  className={`${
                                    transitError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="00000"
                                />
                                {transitError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {transitError}
                                  </p>
                                )}
                              </div>
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Institution Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={institutionNumber}
                                  onChange={(e) =>
                                    setinstitutionNumber(e.target.value)
                                  }
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                              </div>
                            </>
                          )}
                          {(countryCode == "AE" ||
                            countryCode == "GB" ||
                            isEuropeanCountry(countryCode)) && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                IBAN
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={iban}
                                onChange={handleChangeIban}
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="000000"
                              />
                              {error && (
                                <p className="text-red-500 text-sm mt-1">
                                  {error}
                                </p>
                              )}
                            </div>
                          )}
                        </div>

                        {/* Right Column */}
                        <div className="space-y-4 px-4 pt-4">
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 1
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine1}
                              onChange={(e) => setAddressLine1(e.target.value)}
                              className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Street address"
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 2
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine2}
                              onChange={(e) => setAddressLine2(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Apartment, unit etc."
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 3
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine3}
                              onChange={(e) => setAddressLine3(e.target.value)}
                              className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="City, Country etc."
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                        <button
                          onClick={() => {
                            setcurrentBank(null);
                            setIsModalOpenBankEdit(false);
                          }}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (countryCode == "AU" && !toBsb) {
                              showToast("Please enter a valid BSB", "error");
                              return;
                            }
                            if (
                              countryCode == "US" &&
                              (!routingNumber || routingError)
                            ) {
                              showToast(
                                "Please enter a valid routing number",
                                "error"
                              );
                              return;
                            }
                            if (
                              (countryCode == "AE" ||
                                countryCode == "GB" ||
                                isEuropeanCountry(countryCode)) &&
                              !iban
                            ) {
                              showToast("Please enter iban", "error");
                              return;
                            }
                            if (
                              countryCode == "CA" &&
                              (!transitNumber || transitError)
                            ) {
                              showToast(
                                "Please enter a valid transit number",
                                "error"
                              );
                              return;
                            }
                            if (countryCode == "CA" && !institutionNumber) {
                              showToast(
                                "Please enter institution number",
                                "error"
                              );
                              return;
                            }
                            if (!swiftCode) {
                              showToast(
                                "Please enter swift code/BIC code",
                                "error"
                              );
                              return;
                            }
                            if (error) {
                              showToast("Please enter valid iban", "error");
                              return;
                            }
                            if (
                              countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) &&
                              !toAccountNumber
                            ) {
                              showToast("Please enter account number", "error");
                              return;
                            }
                            if (
                              !toAccountName ||
                              !toCurrency ||
                              !addressLine1 ||
                              !addressLine2 ||
                              !addressLine3 ||
                              !countryCode ||
                              !toBank
                            ) {
                              showToast("Please Add all fields", "error");
                              return;
                            }
                            setLoading(true);
                            handleEditBank(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Edit Bank
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className=" max-h-[70vh]  font-medium overflow-y-auto mb-6">
                {bankdata.map((bank, index) => (
                  <div className="relative  p-2 rounded-lg border shadow bg-white mb-6">
                    {/* Edit Button Top-Right */}
                    <button
                      onClick={() => handleEditClick(bank)}
                      className="absolute top-8 right-4 px-3 rounded-md text-sm transition-colors duration-200"
                    >
                      <img
                        onClick={() => handleEditClick(bank)}
                        src="/edit-details.svg" // Replace with the actual path to your edit icon
                        alt="Edit Icon"
                        className="w-4 h-4 cursor-pointer"
                      />
                    </button>

                    {/* Profile Details */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full">
                      {/* Column 1 */}
                      <div className="flex flex-col md:px-4 md:pt-6">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          {index + 1}. Bank Name
                        </label>
                        <span className="text-sm">{bank.bank_name}</span>
                        <div className="mt-4">
                          <label
                            htmlFor="investmentType"
                            className="mb-1 text-xs text-[#A6A6A6]"
                          >
                            Country Code
                          </label>
                          <div className="text-sm">{bank.country_code}</div>
                        </div>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs"
                        >
                          <span className="text-[#A6A6A6]">Status</span>
                        </label>
                        <div className="text-sm">
                          {bank.status === "proof_attached"
                            ? "Proof Attached"
                            : bank.status
                            ? bank.status.charAt(0).toUpperCase() +
                              bank.status.slice(1)
                            : ""}
                        </div>
                      </div>

                      {/* Column 2 */}
                      <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l">
                        <label className="mb-1 mt-4 text-xs text-[#A6A6A6]">
                          Account Name
                        </label>
                        <span className="text-sm">{bank.account_name}</span>
                        <label className="mb-1 mt-4 text-xs text-[#A6A6A6]">
                          Other Details
                        </label>
                        <span className="text-xs">
                          <p>
                            <span className="text-gray-500 font-medium">
                              BSB:
                            </span>{" "}
                            <span className="text-black">
                              {bank.account_bsb ?? "N/A"}
                            </span>
                          </p>
                          <p>
                            <span className="text-gray-500 font-medium">
                              Swift Code:
                            </span>{" "}
                            <span className="text-black">
                              {bank.swift_code ?? "N/A"}
                            </span>
                          </p>
                          <p>
                            <span className="text-gray-500 font-medium">
                              Institution Number:
                            </span>{" "}
                            <span className="text-black">
                              {bank.institution_number ?? "N/A"}
                            </span>
                          </p>
                          <p>
                            <span className="text-gray-500 font-medium">
                              Transit Number:
                            </span>{" "}
                            <span className="text-black">
                              {bank.transit_number ?? "N/A"}
                            </span>
                          </p>
                        </span>
                      </div>

                      {/* Column 3 */}
                      <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                        <label className="mb-1 text-xs text-[#A6A6A6]">
                          Account Number or IBAN
                        </label>
                        <div className="text-sm">
                          {bank.account_number ?? bank.iban}
                        </div>
                        <label className="mb-1 mt-4 text-xs text-[#A6A6A6]">
                          Currency
                        </label>
                        <div className="text-sm">
                          {bank?.currency?.name || "N/A"}
                        </div>
                        {(bank.status === "proof_attached" ||
                          bank.status === "approved" ||
                          bank.status === "rejected") && (
                          <div className="mb-2 mt-4">
                            <label className="mb-1 text-xs text-[#A6A6A6]">
                              Document
                            </label>
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(e, bank);
                              }}
                              className="text-sm underline cursor-pointer"
                            >
                              View Image
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Column 4 */}
                      <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                        <label className="mb-1 text-xs text-[#A6A6A6]">
                          Address
                        </label>
                        <div className="text-sm">
                          {bank.address_line1 || ""}
                        </div>
                        <div className="text-sm">
                          {bank.address_line2 || ""}
                        </div>
                        <div className="text-sm">
                          {bank.address_line3 || ""}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {bankTab === "thpBank" && (
            <div className="w-full p-4 bg-white rounded-lg shadow-lg">
              {/* Header Section */}
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 pb-5 border-gray-100">
                {/* Left: Title */}
                <div className="flex items-center">
                  <img
                    src="/cards.svg"
                    alt="Company Logo"
                    className="mr-2 w-6 h-6"
                  />
                  <span className="font-medium lg:text-xl text-sm">
                    Third Party Bank Accounts
                  </span>
                </div>

                {/* Right: Count and Button */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full md:w-auto justify-end">
                  <div className="flex items-center">
                    <div className="relative">
                      <input
                        type="text"
                        className="p-2 pl-8 border rounded-xl"
                        placeholder="Search Bank.."
                        value={searchQuery}
                        onChange={(e) => {
                          setSearchQuery(e.target.value);
                        }}
                      />
                      <span className="absolute left-2 top-3 text-gray-500">
                        {" "}
                        <img
                          src="/search-normal.svg"
                          alt="Company Logo"
                          className="mr-2"
                        />
                      </span>
                    </div>
                  </div>
                  <p className="text-sm">
                    <span className="font-medium text-labelLightColour">
                      No of Bank Accounts:{" "}
                    </span>
                    <span className="font-medium text-black">
                      {externalbankTable.length}
                    </span>
                  </p>
                  <button
                    onClick={togglePopupAddTransactionCashAccount}
                    className="flex items-center text-[#005A9C] bg-white border border-[#005A9C] py-2 px-3 sm:px-4 rounded-xl w-full sm:w-auto justify-center"
                  >
                    <img src="/Plus.svg" alt="Add Icon" className="mr-2 ml-2" />
                    <span className="inline">Add Bank</span>
                  </button>
                </div>
              </div>

              {isOpenEditCashAccount && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div>
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Add New Third Party Bank
                        </h2>
                        <div className="flex justify-end">
                          <img
                            onClick={togglePopupAddTransactionCashAccount}
                            src="/add.svg"
                            alt="Add"
                            className="w-10 h-10 cursor-pointer"
                          />
                        </div>
                      </div>
                      <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                        {/* Left Column */}
                        <div className="space-y-4 pt-4 px-4">
                          {/* Code */}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Account Name
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={toAccountName}
                              onChange={(e) => setToAccountName(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="John Doe"
                            />
                          </div>
                          {countryCode != "AE" &&
                            countryCode != "GB" &&
                            !isEuropeanCountry(countryCode) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Account Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toAccountNumber}
                                  onChange={(e) =>
                                    setToAccountNumber(e.target.value)
                                  }
                                  className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="0291288"
                                />
                              </div>
                            )}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Bank Name
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={toBank}
                              onChange={(e) => setToBank(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Bank Name"
                            />
                          </div>
                        </div>

                        {/* Center Column with Border */}
                        <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                          <div className="">
                            <Dropdown
                              label="Select Country"
                              options={countryCodeData}
                              search={true}
                              preselectedValue={preselectedCountryCode}
                              onSelect={handleSelectCountryCode}
                              colorLabel=""
                            />
                          </div>
                          <div className="">
                            <Dropdown
                              label="Currency"
                              options={currencyData}
                              search={true}
                              preselectedValue={preselectedcashCurrency}
                              onSelect={handleSelectToCurrency}
                              colorLabel=""
                            />
                          </div>
                          {countryCode == "AU" && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                BSB
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBsb}
                                maxLength={6}
                                onChange={(e) =>
                                  handleBsbChange(e.target.value)
                                }
                                className={`${
                                  bsbError
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {bsbError && (
                                <p className="text-red-600 text-xs mt-1">
                                  {bsbError}
                                </p>
                              )}
                            </div>
                          )}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Swift/BIC code
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={swiftCode}
                              onChange={handleSwiftChange}
                              className={`${
                                swiftError&& countryCode != "AU" 
                                  ? "border-red-300 "
                                  : "border-gray-300 "
                              }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                              placeholder="000000"
                            />
                            {swiftError && countryCode != "AU" && (
                              <p className="text-red-500 text-xs mt-1">
                                {swiftError}
                              </p>
                            )}
                          </div>
                          {countryCode == "US" && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Routing Number (ABA)
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={routingNumber}
                                maxLength={9}
                                onChange={(e) =>
                                  handleRoutingChange(e.target.value)
                                }
                                className={`${
                                  routingError
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000000"
                              />
                              {routingError && (
                                <p className="text-red-600 text-sm mt-1">
                                  {routingError}
                                </p>
                              )}
                            </div>
                          )}
                          {countryCode == "CA" && (
                            <>
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Transit Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={transitNumber}
                                  maxLength={5}
                                  onChange={(e) =>
                                    handleTransitChange(e.target.value)
                                  }
                                  className={`${
                                    transitError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="00000"
                                />
                                {transitError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {transitError}
                                  </p>
                                )}
                              </div>
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Institution Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={institutionNumber}
                                  onChange={(e) =>
                                    setinstitutionNumber(e.target.value)
                                  }
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                              </div>
                            </>
                          )}
                          {(countryCode == "AE" ||
                            countryCode == "GB" ||
                            isEuropeanCountry(countryCode)) && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                IBAN
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={iban}
                                onChange={handleChangeIban}
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="000000"
                              />
                              {error && (
                                <p className="text-red-500 text-sm mt-1">
                                  {error}
                                </p>
                              )}
                            </div>
                          )}
                        </div>

                        {/* Right Column */}
                        <div className="space-y-4 px-4 pt-4">
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 1
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine1}
                              onChange={(e) => setAddressLine1(e.target.value)}
                              className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Street address"
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 2
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine2}
                              onChange={(e) => setAddressLine2(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Apartment, unit etc."
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 3
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine3}
                              onChange={(e) => setAddressLine3(e.target.value)}
                              className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="City, Country etc."
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                        <button
                          onClick={togglePopupAddTransactionCashAccount}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (countryCode == "AU" && (!toBsb || bsbError)) {
                              showToast("Please enter a valid BSB", "error");
                              return;
                            }
                            if (countryCode == "US" && !routingNumber) {
                              showToast(
                                "Please enter a valid routing number",
                                "error"
                              );
                              return;
                            }
                            if (
                              (countryCode == "AE" ||
                                countryCode == "GB" ||
                                isEuropeanCountry(countryCode)) &&
                              !iban
                            ) {
                              showToast("Please enter iban", "error");
                              return;
                            }
                            if (error) {
                              showToast("Please enter valid iban", "error");
                              return;
                            }
                            if (
                              countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) &&
                              !toAccountNumber
                            ) {
                              showToast("Please enter account number", "error");
                              return;
                            }
                            if (
                              countryCode == "CA" &&
                              (!transitNumber || transitError)
                            ) {
                              showToast(
                                "Please enter a valid  transit number",
                                "error"
                              );
                              return;
                            }
                            if (countryCode == "CA" && !institutionNumber) {
                              showToast(
                                "Please enter institution number",
                                "error"
                              );
                              return;
                            }
                            if (countryCode != "AU"&& (!swiftCode || swiftError)) {
                              showToast(
                                "Please enter a valid swift code/BIC code",
                                "error"
                              );
                              return;
                            }
                            if (
                              !toAccountName ||
                              !toCurrency ||
                              !addressLine1 ||
                              !addressLine2 ||
                              !addressLine3 ||
                              !countryCode ||
                              !toBank
                            ) {
                              showToast("Please Add all fields", "error");
                              return;
                            }
                            setLoading(true);
                            handleThirdPartyBank(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Add Bank
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isModalOpenBankEdit && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div>
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Edit Third Party Bank
                        </h2>
                        <div className="flex justify-end">
                          <img
                            onClick={() => {
                              setcurrentBank(null);
                              setIsModalOpenBankEdit(false);
                            }}
                            src="/add.svg"
                            alt="Add"
                            className="w-10 h-10 cursor-pointer"
                          />
                        </div>
                      </div>
                      <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                        {/* Left Column */}
                        <div className="space-y-4 pt-4 px-4">
                          {/* Code */}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Account Name
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={toAccountName}
                              onChange={(e) => setToAccountName(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="John Doe"
                            />
                          </div>
                          {countryCode != "AE" &&
                            countryCode != "GB" &&
                            !isEuropeanCountry(countryCode) && (
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Account Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={toAccountNumber}
                                  onChange={(e) =>
                                    setToAccountNumber(e.target.value)
                                  }
                                  className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="0291288"
                                />
                              </div>
                            )}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Bank Name
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={toBank}
                              onChange={(e) => setToBank(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Bank Name"
                            />
                          </div>
                        </div>

                        {/* Center Column with Border */}
                        <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                          <div className="">
                            <Dropdown
                              label="Select Country"
                              options={countryCodeData}
                              search={true}
                              preselectedValue={preselectedCountryCode}
                              onSelect={handleSelectCountryCode}
                              colorLabel=""
                            />
                          </div>
                          <div className="">
                            <Dropdown
                              label="Currency"
                              options={currencyData}
                              search={true}
                              preselectedValue={preselectedcashCurrency}
                              onSelect={handleSelectToCurrency}
                              colorLabel=""
                            />
                          </div>
                          {countryCode == "AU" && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                BSB
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={toBsb}
                                maxLength={6}
                                onChange={(e) =>
                                  handleBsbChange(e.target.value)
                                }
                                className={`${
                                  bsbError
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {bsbError && (
                                <p className="text-red-600 text-xs mt-1">
                                  {bsbError}
                                </p>
                              )}
                            </div>
                          )}
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Swift/BIC code
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={swiftCode}
                              onChange={handleSwiftChange}
                              className={`${
                                swiftError&& countryCode != "AU" 
                                  ? "border-red-300 "
                                  : "border-gray-300 "
                              }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                              placeholder="000000"
                            />
                            {swiftError&& countryCode != "AU"  && (
                              <p className="text-red-500 text-xs mt-1">
                                {swiftError}
                              </p>
                            )}
                          </div>
                          {countryCode == "US" && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                Routing Number (ABA)
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={routingNumber}
                                maxLength={9}
                                onChange={(e) =>
                                  handleRoutingChange(e.target.value)
                                }
                                className={`${
                                  routingError
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000000"
                              />
                              {routingError && (
                                <p className="text-red-600 text-sm mt-1">
                                  {routingError}
                                </p>
                              )}
                            </div>
                          )}
                          {countryCode == "CA" && (
                            <>
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Transit Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={transitNumber}
                                  maxLength={5}
                                  onChange={(e) =>
                                    handleTransitChange(e.target.value)
                                  }
                                  className={`${
                                    transitError
                                      ? "border-red-300 "
                                      : "border-gray-300 "
                                  }
                                  bg-white border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                  placeholder="00000"
                                />
                                {transitError && (
                                  <p className="text-red-600 text-xs mt-1">
                                    {transitError}
                                  </p>
                                )}
                              </div>
                              <div>
                                <label
                                  htmlFor="finInstituition"
                                  className="mb-1 text-sm text-labelColour"
                                >
                                  Institution Number
                                </label>{" "}
                                <input
                                  id="finInstituition"
                                  type="text"
                                  value={institutionNumber}
                                  onChange={(e) =>
                                    setinstitutionNumber(e.target.value)
                                  }
                                  className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                  placeholder="000000"
                                />
                              </div>
                            </>
                          )}
                          {(countryCode == "AE" ||
                            countryCode == "GB" ||
                            isEuropeanCountry(countryCode)) && (
                            <div>
                              <label
                                htmlFor="finInstituition"
                                className="mb-1 text-sm text-labelColour"
                              >
                                IBAN
                              </label>{" "}
                              <input
                                id="finInstituition"
                                type="text"
                                value={iban}
                                onChange={handleChangeIban}
                                className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                                placeholder="000000"
                              />
                              {error && (
                                <p className="text-red-500 text-sm mt-1">
                                  {error}
                                </p>
                              )}
                            </div>
                          )}
                        </div>

                        {/* Right Column */}
                        <div className="space-y-4 px-4 pt-4">
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 1
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine1}
                              onChange={(e) => setAddressLine1(e.target.value)}
                              className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Street address"
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 2
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine2}
                              onChange={(e) => setAddressLine2(e.target.value)}
                              className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Apartment, unit etc."
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Address Line 3
                            </label>{" "}
                            <input
                              id="finInstituition"
                              type="text"
                              value={addressLine3}
                              onChange={(e) => setAddressLine3(e.target.value)}
                              className="bg-white  border  border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="City, Country etc."
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                        <button
                          onClick={() => {
                            setcurrentBank(null);
                            setIsModalOpenBankEdit(false);
                          }}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (countryCode == "AU" && (!toBsb || bsbError)) {
                              showToast("Please enter a valid BSB", "error");
                              return;
                            }
                            if (countryCode == "US" && !routingNumber) {
                              showToast(
                                "Please enter a valid routing number",
                                "error"
                              );
                              return;
                            }
                            if (
                              (countryCode == "AE" ||
                                countryCode == "GB" ||
                                isEuropeanCountry(countryCode)) &&
                              !iban
                            ) {
                              showToast("Please enter iban", "error");
                              return;
                            }
                            if (
                              countryCode == "CA" &&
                              (!transitNumber || transitError)
                            ) {
                              showToast(
                                "Please enter a valid transit number",
                                "error"
                              );
                              return;
                            }
                            if (countryCode == "CA" && !institutionNumber) {
                              showToast(
                                "Please enter institution number",
                                "error"
                              );
                              return;
                            }
                            if (countryCode != "AU"&& (!swiftCode || swiftError)) {
                              showToast(
                                "Please enter a valid swift code/BIC code",
                                "error"
                              );
                              return;
                            }
                            if (error) {
                              showToast("Please enter valid iban", "error");
                              return;
                            }
                            if (
                              countryCode != "AE" &&
                              countryCode != "GB" &&
                              !isEuropeanCountry(countryCode) &&
                              !toAccountNumber
                            ) {
                              showToast("Please enter account number", "error");
                              return;
                            }
                            if (
                              !toAccountName ||
                              !toCurrency ||
                              !addressLine1 ||
                              !addressLine2 ||
                              !addressLine3 ||
                              !countryCode ||
                              !toBank
                            ) {
                              showToast("Please Add all fields", "error");
                              return;
                            }
                            setLoading(true);
                            handleEditBank(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Edit Bank
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className=" max-h-[70vh]  font-medium overflow-y-auto mb-6">
                {externalbankTable.map((bank, index) => (
                  <div className="relative  p-2 rounded-lg border shadow bg-white mb-6">
                    {/* Edit Button Top-Right */}
                    <button
                      onClick={() => handleEditClick(bank)}
                      className="absolute top-8 right-4 px-3 rounded-md text-sm transition-colors duration-200"
                    >
                      <img
                        src="/edit-details.svg" // Replace with the actual path to your edit icon
                        alt="Edit Icon"
                        className="w-4 h-4 cursor-pointer"
                      />
                    </button>

                    {/* Profile Details */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full">
                      {/* Column 1 */}
                      <div className="flex flex-col md:px-4 md:pt-6">
                        <label
                          htmlFor="refId"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          {index + 1}. Bank Name
                        </label>
                        <span className="text-sm">{bank.bank_name}</span>
                        <div className="mt-4">
                          <label
                            htmlFor="investmentType"
                            className="mb-1 text-xs text-[#A6A6A6]"
                          >
                            Country Code
                          </label>
                          <div className="text-sm">{bank.country_code}</div>
                        </div>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs"
                        >
                          <span className="text-[#A6A6A6]">Status</span>
                        </label>
                        <div className="text-sm">
                          {bank.status === "proof_attached"
                            ? "Proof Attached"
                            : bank.status
                            ? bank.status.charAt(0).toUpperCase() +
                              bank.status.slice(1)
                            : ""}
                        </div>
                      </div>

                      {/* Column 2 */}
                      <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l">
                        <label className="mb-1 text-xs text-[#A6A6A6]">
                          Account Name
                        </label>
                        <span className="text-sm">{bank.account_name}</span>
                        <label className="mb-1 mt-4 text-xs text-[#A6A6A6]">
                          Other Details
                        </label>
                        <span className="text-xs">
                          <p>
                            <span className="text-gray-500 font-medium">
                              BSB:
                            </span>{" "}
                            <span className="text-black">
                              {bank.account_bsb ?? "N/A"}
                            </span>
                          </p>
                          <p>
                            <span className="text-gray-500 font-medium">
                              Swift Code:
                            </span>{" "}
                            <span className="text-black">
                              {bank.swift_code ?? "N/A"}
                            </span>
                          </p>
                          <p>
                            <span className="text-gray-500 font-medium">
                              Institution Number:
                            </span>{" "}
                            <span className="text-black">
                              {bank.institution_number ?? "N/A"}
                            </span>
                          </p>
                          <p>
                            <span className="text-gray-500 font-medium">
                              Transit Number:
                            </span>{" "}
                            <span className="text-black">
                              {bank.transit_number ?? "N/A"}
                            </span>
                          </p>
                        </span>
                      </div>

                      {/* Column 3 */}
                      <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                        <label className="mb-1 text-xs text-[#A6A6A6]">
                          Account Number or IBAN
                        </label>
                        <div className="text-sm">
                          {bank.account_number ?? bank.iban}
                        </div>
                        <label className="mb-1 mt-4 text-xs text-[#A6A6A6]">
                          Currency
                        </label>
                        <div className="text-sm">
                          {bank?.currency?.name || "N/A"}
                        </div>
                        {(bank.status === "proof_attached" ||
                          bank.status === "approved" ||
                          bank.status === "rejected") && (
                          <div className="mb-2 mt-4">
                            <label className="mb-1 text-xs text-[#A6A6A6]">
                              Document
                            </label>
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(e, bank);
                              }}
                              className="text-sm underline cursor-pointer"
                            >
                              View Image
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Column 4 */}
                      <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                        <label className="mb-1 text-xs text-[#A6A6A6]">
                          Address
                        </label>
                        <div className="text-sm">
                          {bank.address_line1 || ""}
                        </div>
                        <div className="text-sm">
                          {bank.address_line2 || ""}
                        </div>
                        <div className="text-sm">
                          {bank.address_line3 || ""}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {isModalOpen && currentDocument && (
            <DocumentPreview
              fileUrl={currentDocument.proof_image_url}
              fileName={currentDocument.proof_image_name}
              onClose={() => setIsModalOpen(false)}
            />
          )}
        </div>
      )}
      {filter == "accounts" && (
        <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            {/* Header Section */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-100">
              <div className="flex items-center mb-2 md:mb-0">
                <img
                  src="/card-tick.svg"
                  alt="Company Logo"
                  className="mr-3 w-6 h-6"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Active Accounts
                </span>
              </div>
              <p className="text-sm">
                <span className="font-medium text-labelLightColour">
                  No of Active Accounts:{" "}
                </span>
                <span className="font-medium text-black">
                  {accountdata.no_of_active_accounts}
                </span>
              </p>
            </div>

            {/* Profile Section */}
            <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
              {/* Profile Details */}
              <div className="grid border-b  grid-cols-1 sm:grid-cols-2 md:grid-cols-4 md:gap-6 gap-2 w-full ">
                {/* Column 1 */}
                <div className="flex flex-col md:px-4 md:pt-6">
                  <div className="flex flex-col  bg-[#5D88F8] px-3 py-2 rounded-xl bg-opacity-50">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-white font-semibold"
                    >
                      Cash Account
                    </label>
                    <span className="text-sm font-semibold">
                      $
                      {accountdata.active_accounts?.cash_account_balance
                        ? accountdata.active_accounts.cash_account_balance
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "0.00"}
                    </span>
                  </div>
                  <div className="flex flex-col mt-4 mb-4 bg-[#996EE7] px-3 py-2 rounded-xl bg-opacity-50">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-white font-semibold"
                    >
                      Private Wealth Account
                    </label>
                    <span className="text-sm font-semibold">
                      $
                      {accountdata.active_accounts?.fund_account_balance
                        ? accountdata.active_accounts.fund_account_balance
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "0.00"}
                    </span>
                  </div>
                </div>

                {/* Column 2 */}
                <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l">
                  <div className="flex flex-col  bg-[#F18C29] px-3 py-2 rounded-xl bg-opacity-50">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-white font-semibold"
                    >
                      Securities
                    </label>
                    <span className="text-sm font-semibold">
                      $
                      {accountdata.active_accounts?.securities
                        ? accountdata.active_accounts.securities.toFixed(2)
                        : "0.00"}
                    </span>
                  </div>

                  <div className="flex flex-col mt-4 md:mb-4 bg-[#DC4646] px-3 py-2 rounded-xl bg-opacity-50">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-white font-semibold"
                    >
                      Trading
                    </label>
                    <span className="text-sm font-semibold">
                      $
                      {accountdata.active_accounts?.trading
                        ? accountdata.active_accounts.trading.toFixed(2)
                        : "0.00"}
                    </span>
                  </div>
                </div>

                {/* Column 3 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <div className="flex flex-col  bg-[#2DB0EC] px-3 py-2 rounded-xl bg-opacity-50">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-white font-semibold"
                    >
                      Custodian
                    </label>
                    <span className="text-sm font-semibold">
                      $
                      {accountdata.active_accounts?.custodian
                        ? accountdata.active_accounts.custodian.toFixed(2)
                        : "0.00"}
                    </span>
                  </div>
                  <div className="flex flex-col mt-4 mb-4 bg-[#6B68F2] px-3 py-2 rounded-xl bg-opacity-50">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-white font-semibold"
                    >
                      My Investment
                    </label>
                    <span className="text-sm font-semibold">
                      $
                      {accountdata.active_accounts?.my_investments
                        ? accountdata.active_accounts.my_investments
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "0.00"}
                    </span>
                  </div>
                </div>
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <div className="flex flex-col  bg-[#34C046] px-3 py-2 rounded-xl bg-opacity-50">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-white font-semibold"
                    >
                      Digital Assets{" "}
                    </label>
                    <span className="text-sm font-semibold">
                      $
                      {accountdata.active_accounts?.asset
                        ? accountdata.active_accounts.asset.toFixed(2)
                        : "0.00"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full p-4 bg-white rounded-lg mt-4 shadow-lg">
            {/* Header Section */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-100">
              <div className="flex items-center mb-2 md:mb-0">
                <img
                  src="/card-tick.svg"
                  alt="Company Logo"
                  className="mr-3 w-6 h-6"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Archived Accounts
                </span>
              </div>
              <p className="text-sm">
                <span className="font-medium text-labelLightColour">
                  No of Archived Accounts:{" "}
                </span>
                <span className="font-medium text-black">
                  {accountdata.no_of_archieved_accounts}
                </span>
              </p>
            </div>

            {/* Profile Section */}
            <div className="flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
              {/* Profile Details */}
              <div className="grid border-b  grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full ">
                {/* Column 1 */}
                <div className="flex flex-col md:px-4 md:pt-6">
                  <div className="flex flex-col  bg-[#5D88F8] px-3 py-2 rounded-xl bg-opacity-50">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-white font-semibold"
                    >
                      Cash Account
                    </label>
                    <span className="text-sm font-semibold">
                      {" "}
                      $
                      {accountdata.archieved_accounts?.no_of_cash_accounts
                        ? accountdata.archieved_accounts.no_of_cash_accounts.toFixed(
                            2
                          )
                        : "0.00"}
                    </span>
                  </div>
                  <div className="flex flex-col mt-4 mb-4 bg-[#996EE7] px-3 py-2 rounded-xl bg-opacity-50">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-white font-semibold"
                    >
                      Private Wealth Account
                    </label>
                    <span className="text-sm font-semibold">
                      $
                      {accountdata.archieved_accounts?.no_of_fund_accounts
                        ? accountdata.archieved_accounts.no_of_fund_accounts.toFixed(
                            2
                          )
                        : "0.00"}
                    </span>
                  </div>
                </div>

                {/* Column 2 */}
                <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l"></div>

                {/* Column 3 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l"></div>
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l"></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerDetails;
